<template>
  <div class="google-authen" :class="{ 'd-none': !visible }">
    <!--begin::Separator-->
    <div class="text-center mb-m">
      {{ $t("form.or") }}
    </div>
    <!--end::Separator-->

    <!--begin::Google link-->
    <a
      href="#"
      class="btn btn-flex justify-content-center btn-light w-100 mb-m"
    >
      <img
        alt="img-logo"
        :src="logoGoogle"
        class="h-20px icon-img mr-xs"
      />{{ $t("form.registerBy", { name: 'Google'}) }}</a>
    <!--end::Google link-->
  </div> <!-- /.google-authen -->
</template>

<script>
import logoGoogle from '@/assets/icons/google-icon.svg';

export default {
  name: 'GoogleSignIn',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoGoogle,
    };
  },
};
</script>
